<template>
  <div class="analysisTypeBtn">
    <v-toolbar
      color="primary"
      dark
      dense
      class="mb-2 analysisTypeBtn__toolbar"
      @click="showChildren = !showChildren"
    >
      <v-btn
        icon
        @click.stop="showChildren = !showChildren"
      >
        <v-icon>
          {{ iconArrow }}
        </v-icon>
      </v-btn>
      <v-row
        align="center"
        justify="center"
      >
        <v-toolbar-title>
          {{ analysisTypeName }}
        </v-toolbar-title>
      </v-row>
    </v-toolbar>
    <v-container v-if="showChildren">
      <AnalysisViewMeasures
        :analysis="analysis"
        :site="site"
        :analyses="analyses"
        :nodes="nodes"
        :isCompletedOrLocked="isCompletedOrLocked"
        :analysisType="analysisType"
      />
    </v-container>
  </div>
</template>

<script>

import { isPlainObject } from 'lodash';
import { mapGetters } from 'vuex';
import AnalysisViewMeasures from '@/components/services/AnalysisViewMeasures.vue';

export default {
    components: {
        AnalysisViewMeasures,
    },
    props: {
        analysisType: {
            type: Object,
            default: () => ({}),
        },
        analyses: {
            type: Object,
            default: () => [],
        },
        analysis: {
            type: Object,
            default: () => ({}),
        },
        site: {
            type: Object,
            default: () => ({}),
        },
        isCompletedOrLocked: {
            type: Boolean,
            default: false,
        },
        nodes: {
            type: [Object, Array],
            default: () => ({}),
        },
    },
    data() {
        return {
            showChildren: false,
            smallWidth: false,
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
            'userLang',
        ]),
        isSmallScreen() {
            return window.innerWidth < 600;
        },
        iconArrow() {
            return this.showChildren ? 'mdi-menu-down' : 'mdi-menu-right';
        },
        analysisTypeName() {
            const { measureUnit, name } = this.analysisType;
            let unit = '';

            if (isPlainObject(measureUnit)) {
                unit = ` (${measureUnit[this.userLang]})`;
            }

            return `${name[this.userLang]}${unit}`;
        },
    },
    mounted() {
        this.updateCustomLandscape();
        window.addEventListener('resize', this.updateCustomLandscape);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateCustomLandscape);
    },
    methods: {
        updateCustomLandscape() {
            this.smallWidth = window.innerWidth > 600;
        },
    // ...
    },
};
</script>
<style scoped lang="scss">

@media screen and (max-width: 600px) {
  .analysisTypeBtn {
    &__toolbar {
      display: flex;
      justify-content: flex-start;
      padding-left: 0 !important;
      .v-toolbar__content {
        padding-left: 0
      }
    }
    button {
      margin: 0 !important;
      margin-right: 5px !important
    }
  }
}
</style>
<style lang="scss">
@media screen and (max-width: 600px) {
  .analysisTypeBtn {
    .v-toolbar--dense .v-toolbar__content, .v-toolbar--dense .v-toolbar__extension {
      padding-left: 0;
    }
  }
}

</style>
